import { PledgeSummaryResponse } from '@http/api-models/PledgeSummaryResponse'
import { apiUrls } from '@http/api-urls'
import { httpService } from '@http/service'
import { NextPageFC } from '@shared/models/next-fc'
import { GetServerSideProps } from 'next'
import { InvestorsFond, InvestorsFondPageProps } from 'screens/investors-fond'

import { RegionalPagesPath, regionalPagesProps } from '../../regions/runtime-components/pages-props'
import { serverSideResolveCity } from '../../ssr-resolvers/next-ssr-resolvers'
import { getSavingsParams } from '../../ssr-resolvers/savings-params'

const InvestorsFondPage: NextPageFC<InvestorsFondPageProps> = (props) => InvestorsFond(props)

InvestorsFondPage.layout = regionalPagesProps[RegionalPagesPath.invest].layout
InvestorsFondPage.headProps = regionalPagesProps[RegionalPagesPath.invest].headProps
InvestorsFondPage.breadcrumb = { title: 'Сбережения' }

export const getServerSideProps: GetServerSideProps<InvestorsFondPageProps> = async (context) => {
	try {
		const [pledgeSummary, savingsParams, cityResult] = await Promise.all([
			httpService.get<PledgeSummaryResponse>(apiUrls.getSummaries()),
			getSavingsParams(),
			serverSideResolveCity(context),
		])

		return {
			props: {
				...(cityResult as any).props,
				pageSettings: {
					...(cityResult as any).props.pageSettings,
					savings: { params: savingsParams },
					pledgeSummary,
				},
			},
		}
	} catch {
		return {
			props: {
				pageSettings: {},
			},
		}
	}
}

export default InvestorsFondPage
